import"../../chunks/index4.js";function t({url:o}){}export{t as load};
//# sourceMappingURL=_layout.server.ts.js.map
